import styled from 'styled-components';

export const ResultsContainer = styled.div`
  padding: 32px;
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 
    0 8px 24px rgba(0, 0, 0, 0.1),
    0 4px 12px rgba(0, 0, 0, 0.06);
  border: 2px solid #e8e8e8;
`;

export const CategorySection = styled.div`
  margin-bottom: 40px;
`;

export const CategoryTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #1890ff;
`;

export const PlaceItem = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 24px;
  margin-bottom: 16px;
  background: #fafafa;
  border: 2px solid #e8e8e8;
  border-radius: 16px;
  gap: 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  &:hover {
    background: #f0f7ff;
    border-color: #1890ff;
    transform: translateX(8px);
    box-shadow: 
      0 4px 12px rgba(24, 144, 255, 0.15),
      0 2px 6px rgba(24, 144, 255, 0.1);
  }
`;

export const MedalIcon = styled.span<{ $place: number }>`
  font-size: 24px;
  ${props => {
    if (props.$place === 1) return 'color: #ffd700;'; // Gold
    if (props.$place === 2) return 'color: #c0c0c0;'; // Silver
    if (props.$place === 3) return 'color: #cd7f32;'; // Bronze
    return 'color: #666;';
  }}
`;

export const InitialsBox = styled.div`
  width: 56px;
  height: 56px;
  background: #e6f7ff;
  border: 2px solid #91d5ff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
  color: #1890ff;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
`;

export const ParticipantInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ParticipantName = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #333;
`;

export const ParticipantDetails = styled.div`
  font-size: 14px;
  color: #666;
`;

